/**
 * Fase 2 «Arquitetura de Conduta e Contexto» §C.5 — a CLASSE do canal.
 *
 * ── O achado que isto endereça ────────────────────────────────────────────────────────
 * `{{channel}}` chega ao prompt do conductor desde sempre (v32 userTemplate) e é lido por
 * **ninguém**: `grep channel` nas diretivas = 0 (levantamento 09, eixo «pago-e-inerte»).
 * A plataforma paga o token e não colhe conduta. Este módulo é a metade barata do
 * conserto: a CLASSE. A prosa que a IA lê é do renderizador do quadro (engine, PR
 * posterior).
 *
 * ── Por que família, e não `ChannelKind` cru ──────────────────────────────────────────
 * `whatsapp-cloud-api` é nome de PRODUTO de um fornecedor; colocá-lo na fala acopla a
 * conduta a um vendor e não ensina nada ao modelo. O que muda a norma de conversa é a
 * classe: mensageria assíncrona (mensagens curtas, o cliente pode responder amanhã) ×
 * janela aberta agora (respostas ágeis, pode ser mais denso) × correio (resposta
 * autocontida, sem quickReplies).
 *
 * ── Camada ────────────────────────────────────────────────────────────────────────────
 * **Camada 1, plataforma.** Canal é FATO técnico da conversa, não preferência do tenant
 * — dois tenants do mesmo tipo de negócio não podem legitimamente querer que WhatsApp
 * seja síncrono (discriminador da regra 6 de `.claude/rules/motor-ia-conductor.md`).
 * Nada aqui nomeia produto, setor, documento ou valor de nenhum mercado.
 */
export const CHANNEL_FAMILIES = [
    /** Mensageria assíncrona no celular — turnos curtos, resposta pode demorar. */
    'messaging',
    /** Janela de chat aberta agora — o cliente está do outro lado neste momento. */
    'webchat',
    /** Correio — a resposta precisa se sustentar sozinha, sem ida-e-volta. */
    'email',
];
/**
 * Os canais canônicos → 3 classes. Exaustivo por construção (`Record<ChannelKind, …>`):
 * canal novo sem família é erro de compilação, não um `else` silencioso.
 */
export const CHANNEL_FAMILY_BY_KIND = {
    'whatsapp-cloud-api': 'messaging',
    telegram: 'messaging',
    'instagram-dm': 'messaging',
    webchat: 'webchat',
    email: 'email',
    // O simulador emula uma janela aberta; a norma de conversa é a mesma do webchat.
    simulador: 'webchat',
};
const FAMILY_BY_RAW = new Map(Object.entries(CHANNEL_FAMILY_BY_KIND));
/**
 * Classe de um valor CRU de canal (`Conversation.channel` é `String` no schema, não enum).
 *
 * `null` para ausente/desconhecido — e deliberadamente NÃO uma 4ª família «unknown»: a
 * família é uma AFIRMAÇÃO sobre a norma do canal, e não se afirma nada sobre um canal
 * que não se conhece. Quem rende a prosa degrada para a forma mais neutra. Nunca lança.
 */
export function channelToFamily(raw) {
    if (typeof raw !== 'string')
        return null;
    const key = raw.trim().toLowerCase();
    if (key.length === 0)
        return null;
    return FAMILY_BY_RAW.get(key) ?? null;
}
//# sourceMappingURL=channel-families.js.map